var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../shared/nunjucks.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("D:/Cloud/cloudmine-panel-core/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["templates/time-range-narrow.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"cm-time-range\">\n    <form target=\"#\" class=\"cm-form\">\n        <div class=\"cm-input\">\n            <label for=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "-to-date\">From date:</label>\n            <input type=\"text\" id=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "-to-date\" name=\"time-to\" class=\"cm-time-from-input\">\n        </div>\n        <div class=\"cm-input\">\n            <label for=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "-from-date\">To date:</label>\n            <input type=\"text\" id=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "-from-date\" name=\"time-from\" class=\"cm-time-to-input\" >\n        </div>\n        <div class=\"btn-group btn-group-justified cm-time-range-radio\" data-toggle=\"buttons\">\n            <label class=\"btn btn-default btn-sm active\">\n                <input type=\"radio\" value=0 name=\"time-range\" checked> Flexible\n            </label>\n            <label class=\"btn btn-default btn-sm\">\n                <input type=\"radio\" value=\"P30D\" name=\"time-range\"> 30 days\n            </label>\n            <label class=\"btn btn-default btn-sm\">\n                <input type=\"radio\" value=\"P14D\" name=\"time-range\"> 14 days\n            </label>\n        </div>\n    </form>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["templates/time-range-narrow.html"] , dependencies)